<div class="row pt-3 full-width" id="block-container">
    <hr class="col">
    <b class="pl-3 pt-1 pr-3"> {{ "or" | translate }} </b>
    <hr class="col">
</div>
